import StoragePlace from '../../../components/basic/general/StoragePlace';

//组件 
const WebComponents = () => {
    return (
        <StoragePlace sendPageData={{ type: 'asset' }} />
    )
}
export default WebComponents;
